import { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Button, Flex, Text, TextField, Spinner, Heading } from '@radix-ui/themes'
import { ChevronLeftIcon } from '@radix-ui/react-icons'
import * as Yup from 'yup'
import { clearUser, updateUser } from '../../redux/slices/userSlice'
import { clearAccount, updateAccount } from '../../redux/slices/accountSlice'
import { clearTeacherAccount, updateTeacherAccount } from '../../redux/slices/teacherAccountSlice'
import { clearStudentAccount, updateStudentAccount } from '../../redux/slices/studentAccountSlice'
import { clearGuardian, updateGuardian } from '../../redux/slices/guardianSlice'
import { updateSchoolAdminAccount } from '../../redux/slices/schoolAdminAccountSlice'
import { toast } from 'react-toastify'
import api from '../../api'
import { loginUser } from '../../services/authService'
import OtpInput from 'react-otp-input';
import ReCAPTCHA from "react-google-recaptcha"
// import {setupAuthenticatedAccount} from '../../services/authService'

const LoginForm = () => {
    const GOOGLE_SITE_KEY = import.meta.env.VITE_GOOGLE_SITE_KEY
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [step, setStep] = useState(1)
    const [otp, setOtp] = useState("");
    const [OTPLoading, setOTPLoading] = useState(false)
    const [verificationRequestData, setVerificationRequestData] = useState(null)
    const [submittedData, setSubmittedData] = useState(null); //Data on step 1 
    const [isNotARobot, setIsNotARobot] = useState(false);

    const formik = useFormik({
        initialValues: {
            phone: '',
        },
        validationSchema: Yup.object({
            phone: Yup.string()
                .matches(/^[0-9]{7,10}$/, 'Phone number must be between 7 and 10 digits')
                .required('Phone number is required'),
        }),
        onSubmit: async (values) => {
            try {
                setLoading(true)
                const userData = {
                    phone: values.phone,
                }

                const loginData = await loginUser(userData)
                console.log('login response', loginData);

                if (loginData.error) {
                    formik.setErrors(loginData.error)
                    toast.error(loginData.error, {
                        position: "bottom-right"
                    });
                } else {
                    formik.setErrors({});
                    formik.setStatus(null);
                    setVerificationRequestData(loginData.details.data)
                    setStep(2)
                    setSubmittedData(userData);
                }
            } catch (err) {
                console.error('Login failed', err)
                if (err.response?.data.error) {
                    formik.setStatus(err.response?.data.error)
                } else if (err.response?.data.errors) {
                    formik.setErrors(err.response?.data.errors)
                } else if (err.response?.data.message) {
                    formik.setStatus(err.response?.data.message)
                } else {
                    formik.setStatus('Login failed. Please try again.')
                }
            } finally {
                setLoading(false)
            }
        }
    })

    /**
     * Resets the OTP and goes back to step 1
     */
    const handleGoBack = () => {
        setStep(1)
        setOtp("")
    }

    /**
    * Resends OTP for registration verification
    * @param {Event} e - The event object
    */
    const handleResendOTP = async (e) => {
        e.preventDefault()
        console.log('resending otp')
        try {

            const userData = {
                'request_id': verificationRequestData.requestId ?? verificationRequestData.id,
            }

            const response = await api.post(`/resend-otp`, userData)

            console.log('resend otp response::', response)

            setVerificationRequestData(response.data.details.data)

            toast.success("OTP has been successfully resent", {
                position: "bottom-right",
            });

        } catch (err) {
            console.log('error resending otp::', err.response.data.error)
            //An error occured while verifying, try again
            toast.error(err.response.data.error, {
                position: "bottom-right",
            });
        }
    }


    const handleVerification = async (e) => {
        e.preventDefault()
        setOTPLoading(true)

        if (otp.length < 4) {
            toast.error("Enter the OTP", {
                position: "bottom-right",
            });
            return
        }

        try {
            const userData = {
                ...submittedData,
                'request_id': verificationRequestData.requestId ?? verificationRequestData.id,
                'prefix': verificationRequestData.prefix,
                'code': otp,
            }

            const response = await api.post(`/verify-login`, userData)

            console.log('LOGIN RESPONSE>>>>>>>>::', response.data)

            let data = response.data
            console.log('LOGIN DATA', { ...data.user, account: data.account.details });

            // Clear all existing data
            // localStorage.removeItem('authToken')
            // localStorage.removeItem('userDetails')
            // localStorage.removeItem('accountDetails')
            // localStorage.removeItem('persist:studentAccountDetails')
            // localStorage.removeItem('persist:teacherAccountDetails')
            // localStorage.removeItem('persist:guardianDetails')
            // localStorage.removeItem('persist:schoolAdminAccountDetails')

            localStorage.clear();

            // Clear all Redux state
            // dispatch(clearUser())
            // dispatch(clearAccount())
            // dispatch(clearStudentAccount())
            // dispatch(clearTeacherAccount())
            // dispatch(clearGuardian())
            // dispatch(clearSchoolAdminAccount())

            // Clear all localStorage
            localStorage.clear();

            // Set new user data
            dispatch(updateUser({ ...data.user, account: data.account.details }));
            dispatch(updateAccount(data.account));

            localStorage.setItem('authToken', data.user.authToken)

            switch (data.user.details.role) {
                case 'student':
                    dispatch(updateStudentAccount(data.account))
                    navigate('/student')
                    break
                case 'teacher':
                    dispatch(updateTeacherAccount(data.account))
                    navigate('/teacher');
                    break
                case 'school':
                    console.log('identified school admin account', data);
                    dispatch(updateSchoolAdminAccount(data.account))
                    navigate('/school')
                    break
                case 'guardian':
                    console.log('guardian data', data);
                    dispatch(updateGuardian(data.account))
                    navigate('/guardian')
                    break;
                default:
                    navigate('/dashboard')
                    break
            }
        } catch (err) {
            console.log('error verifying::', err)

            //An error occured while verifying, try again
            if (err.response?.data.error) {
                toast.error(err.response?.data.error, {
                    position: "bottom-right",
                });
            } else {
                toast.error('An unexpected error occured, try again', {
                    position: "bottom-right",
                });
            }

        } finally {
            setOTPLoading(false)
        }

    }

    function onReCaptchaChange(value) {
        // console.log("Captcha value:", value);
        setIsNotARobot(true);
    }

    return (
        <>
            {step == 1 ? (
                <form onSubmit={formik.handleSubmit}>
                    {formik.status && (
                        <Flex direction="column" justify="center" align="center">
                            <Text color="red" mb="4">{formik.status}</Text>
                        </Flex>
                    )}

                    <Flex direction="column" gap="4">
                        <TextField.Root
                            name="phone"
                            type="phone"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Phone Number"
                            size="3"
                        />
                        {formik.touched.phone && formik.errors.phone &&
                            <Text color="red" size="2">{formik.errors.phone}</Text>
                        }

                        <Flex justify={'center'}>
                            <ReCAPTCHA
                                sitekey={GOOGLE_SITE_KEY}
                                onChange={onReCaptchaChange}
                            />
                        </Flex>

                        {/* <Button disabled={loading || !isNotARobot} type="submit" className='cursor-pointer'> */}
                        <Button disabled={loading} type="submit" className='cursor-pointer'>
                            {loading ? (
                                <Flex gap="2" align="center">
                                    <Spinner size="1" />
                                    Loading...
                                </Flex>
                            ) : (
                                'Login'
                            )}
                        </Button>

                        <Button
                            onClick={() => navigate('/register')}
                            color="cyan"
                            variant="soft"
                            className='cursor-pointer'
                        >
                            Create a new account
                        </Button>
                    </Flex>
                </form>
            ) : (
                <Flex direction="column" gap="1" align="center" justify="center">

                    <Flex align="center" onClick={handleGoBack} className="cursor-pointer"> <ChevronLeftIcon /> <Text color="blue">Go back</Text></Flex>

                    <Text>Enter the verification code sent to <Text color="cyan" weight="bold">{submittedData && submittedData.phone}</Text></Text>

                    <Text>
                        <Text>
                            Didn't receive OTP{" "}
                            <Text color="cyan" onClick={(e) => handleResendOTP(e)}>
                                <Text color="cyan" onClick={(e) => handleResendOTP(e)}>
                                    Resend OTP
                                </Text>
                            </Text>
                        </Text>
                    </Text>

                    <div className="my-5">
                        <OtpInput
                            inputStyle={{ width: "2.5rem", height: "3rem", margin: "0 1rem", fontSize: "1.5rem", borderRadius: "var(--radius-4)", border: "1px solid var(--accent-7)" }}
                            value={otp}
                            onChange={setOtp}
                            numInputs={4}
                            renderSeparator={<span>-</span>}
                            renderInput={(props) => <input {...props} />}

                        />
                    </div>

                    <Button disabled={OTPLoading || otp.length < 4} onClick={(e) => handleVerification(e)} className='cursor-pointer w-full'>
                        {OTPLoading ? (
                            <Flex gap="2" align="center">
                                <Spinner size="1" />
                                Loading...
                            </Flex>
                        ) : (
                            'Verify'
                        )}
                    </Button>

                    {/* <p className="text-base">Didn't receive the code? Dial <span className='font-bold'>*713*90#</span> to view it</p> */}

                </Flex>
            )}
        </>

    )
}

export default LoginForm 